/* Sérénelle · bannière « patchs en apesanteur »
   À l'arrivée : la photo apparaît sans patchs, les patchs flottent en 3D (apesanteur),
   puis se posent un à un exactement sur le front, sous les yeux et sur le décolleté. Le texte apparaît en même temps.
   L'animation ne se joue qu'une fois ; ensuite tout reste fixe. */
(() => {
  'use strict';
  const H = document.querySelector('[data-h3]');
  if (!H) return;
  const vis = H.querySelector('.lis-hero-vis');
  const photo = H.querySelector('.h3-photo');
  const nu = H.querySelector('.h3-nu');
  const fini = H.querySelector('.h3-fini');
  const scene = H.querySelector('.h3-scene');
  const patchs = Array.from(H.querySelectorAll('.h3-p'));

  /* Téléphone : le visage et le décolleté pile au centre de l'écran, quelle que soit la taille du téléphone */
  const AXE = 0.742; /* milieu des patchs sur la photo (de 0 à 1) */
  const centrer = () => {
    const ref = nu || fini;
    if (!ref || !ref.naturalWidth) return;
    if (!matchMedia('(max-width: 900px)').matches) { [nu, fini].forEach((i) => i && (i.style.objectPosition = '')); return; }
    const r = photo.getBoundingClientRect();
    const dw = ref.naturalWidth * Math.max(r.width / ref.naturalWidth, r.height / ref.naturalHeight);
    if (dw <= r.width + 1) return;
    const p = Math.min(1, Math.max(0, (r.width / 2 - AXE * dw) / (r.width - dw)));
    [nu, fini].forEach((i) => i && (i.style.objectPosition = `${(p * 100).toFixed(2)}% 40%`));
  };
  addEventListener('resize', centrer, { passive: true });
  if (fini) { if (fini.complete && fini.naturalWidth) centrer(); else fini.addEventListener('load', centrer, { once: true }); }

  const terminerVite = () => {
    H.classList.add('h3-go', 'h3-fin');
    setTimeout(() => { H.classList.remove('h3-jouer'); nettoyer(); }, 1400);
  };
  const nettoyer = () => {
    if (scene) scene.remove();
    H.querySelectorAll('.h3-r').forEach((r) => r.remove());
  };
  if (!H.classList.contains('h3-jouer') || !nu || !fini || !scene || !patchs.length) { H.classList.add('h3-go'); return; }

  const grand = matchMedia('(min-width: 901px)').matches;
  const pret = (img) => new Promise((ok) => {
    const fin = () => (img.decode ? img.decode().catch(() => {}) : Promise.resolve()).then(ok);
    if (img.complete && img.naturalWidth) fin();
    else { img.addEventListener('load', fin, { once: true }); img.addEventListener('error', ok, { once: true }); }
  });
  const images = [nu, fini].concat(patchs.map((p) => p.querySelector('img')));
  const delai = new Promise((ok) => setTimeout(() => ok('lent'), 3500));
  Promise.race([Promise.all(images.map(pret)), delai]).then((r) => {
    if (r === 'lent' || !images.every((i) => i.naturalWidth)) terminerVite();
    else requestAnimationFrame(jouer);
  });

  /* Où se trouve la photo (object-fit: cover) dans le bloc visuel */
  const geometrie = () => {
    const rv = vis.getBoundingClientRect(), rp = photo.getBoundingClientRect();
    const pos = getComputedStyle(nu).objectPosition.split(' ').map(parseFloat);
    const iw = nu.naturalWidth, ih = nu.naturalHeight, cw = rp.width, ch = rp.height;
    const s = Math.max(cw / iw, ch / ih), dw = iw * s, dh = ih * s;
    return {
      dw, dh,
      ox: (cw - dw) * ((isNaN(pos[0]) ? 50 : pos[0]) / 100),
      oy: (ch - dh) * ((isNaN(pos[1]) ? 50 : pos[1]) / 100),
      dx: rp.left - rv.left, dy: rp.top - rv.top,
      vw: rv.width, vh: rv.height
    };
  };

  /* Point de départ de chaque patch (en fraction du bloc) et sa rotation dans l'espace */
  const DEPARTS = [
    { x: -0.30, y: -0.20, z: 340, rx: 58, ry: -38, rz: -24 },
    { x: -0.34, y: 0.10, z: 280, rx: -42, ry: 52, rz: 20 },
    { x: 0.30, y: -0.06, z: 310, rx: 36, ry: -56, rz: -16 },
    { x: 0.24, y: -0.30, z: 380, rx: -52, ry: 30, rz: 32 }
  ];
  const PERSP = 'perspective(900px) ';
  const tr = (x, y, z, rx, ry, rz, s) => `${PERSP}translate3d(${x.toFixed(1)}px,${y.toFixed(1)}px,${z}px) rotateX(${rx}deg) rotateY(${ry}deg) rotateZ(${rz}deg) scale(${s})`;
  const flou = (v) => (grand ? `blur(${v}px)` : 'blur(0px)');

  let anims = [], fini3 = false;

  function jouer() {
    centrer();
    const G = geometrie();
    const fond = `url("${fini.currentSrc || fini.src}")`;
    H.classList.add('h3-go');
    let restants = patchs.length;

    patchs.forEach((p, i) => {
      const [x0, y0, x1, y1] = p.dataset.box.split(',').map(Number);
      const [bx0, by0, bx1, by1] = p.dataset.bbox.split(',').map(Number);
      const img = p.querySelector('img');
      /* Emplacement exact du patch sur la photo affichée */
      const T = { x: G.dx + G.ox + x0 * G.dw, y: G.dy + G.oy + y0 * G.dh, w: (x1 - x0) * G.dw, h: (y1 - y0) * G.dh };
      const cx = T.x + T.w / 2, cy = T.y + T.h / 2;
      const A = ((bx1 - bx0) * img.naturalWidth) / ((by1 - by0) * img.naturalHeight);
      let pw, ph;
      if (T.w / T.h > A) { ph = T.h; pw = ph * A; } else { pw = T.w; ph = pw / A; }
      p.style.cssText = `left:${(cx - pw / 2).toFixed(1)}px;top:${(cy - ph / 2).toFixed(1)}px;width:${pw.toFixed(1)}px;height:${ph.toFixed(1)}px`;
      const iw = pw / (bx1 - bx0), ih = iw * img.naturalHeight / img.naturalWidth;
      img.style.cssText = `width:${iw.toFixed(1)}px;height:${ih.toFixed(1)}px;left:${(-bx0 * iw).toFixed(1)}px;top:${(-by0 * ih).toFixed(1)}px`;

      /* Zone de la vraie photo qui apparaît quand le patch se pose */
      const m = 0.24, R = { x: T.x - T.w * m - G.dx, y: T.y - T.h * m - G.dy, w: T.w * (1 + 2 * m), h: T.h * (1 + 2 * m) };
      const r = document.createElement('div');
      r.className = 'h3-r';
      r.style.cssText = `left:${R.x.toFixed(1)}px;top:${R.y.toFixed(1)}px;width:${R.w.toFixed(1)}px;height:${R.h.toFixed(1)}px;background-image:${fond};background-size:${G.dw.toFixed(1)}px ${G.dh.toFixed(1)}px;background-position:${(G.ox - R.x).toFixed(1)}px ${(G.oy - R.y).toFixed(1)}px`;
      photo.appendChild(r);

      /* Mire de visée */
      const c = document.createElement('div');
      const cm = 0.3;
      /* l'étiquette va du côté où il y a de la place */
      c.className = 'h3-cible' + (T.x + T.w * 1.15 + 170 > G.vw || i === 1 ? ' h3-g' : '');
      c.style.cssText = `left:${(T.x - T.w * cm / 2).toFixed(1)}px;top:${(T.y - T.h * cm / 2).toFixed(1)}px;width:${(T.w * (1 + cm)).toFixed(1)}px;height:${(T.h * (1 + cm)).toFixed(1)}px`;
      c.innerHTML = '<i></i><i></i><i></i><i></i>' + (p.dataset.lab && grand ? `<b>${p.dataset.lab}</b>` : '');
      scene.appendChild(c);

      /* Départ : flotte dans l'espace, dans le cadre */
      const d = DEPARTS[i % DEPARTS.length], k = grand ? 1 : 0.75;
      let sx = cx + d.x * G.vw * k, sy = cy + d.y * G.vh * k;
      sx = Math.min(Math.max(sx, pw * 0.7), G.vw - pw * 0.7);
      sy = Math.min(Math.max(sy, ph * 0.9 + 10), G.vh - ph * 0.9 - 10);
      const tx = sx - cx, ty = sy - cy;
      const duree = 3000 + i * 240, attente = 120 + i * 130;

      const a = p.animate([
        { transform: tr(tx, ty + 26, d.z, d.rx, d.ry, d.rz, 0.9), opacity: 0, filter: flou(9), easing: 'cubic-bezier(.2,.7,.3,1)' },
        { transform: tr(tx + 8, ty + 6, d.z, d.rx * 0.9, d.ry * 0.85, d.rz, 1), opacity: 1, filter: flou(3), offset: 0.2, easing: 'cubic-bezier(.45,0,.55,1)' },
        { transform: tr(tx - 10, ty - 14, Math.round(d.z * 0.82), d.rx * 0.55, d.ry * 0.5, d.rz * 0.6, 1), opacity: 1, filter: flou(2), offset: 0.5, easing: 'cubic-bezier(.6,0,.18,1)' },
        { transform: tr(0, 0, 22, 0, 0, 0, 1.03), opacity: 1, filter: flou(0), offset: 0.92, easing: 'cubic-bezier(.3,0,.2,1)' },
        { transform: tr(0, 0, 0, 0, 0, 0, 1), opacity: 1, filter: flou(0) }
      ], { duration: duree, delay: attente, fill: 'both' });
      anims.push(a);

      const ac = c.animate([
        { opacity: 0, transform: 'scale(1.35)' },
        { opacity: 0.9, transform: 'scale(1)', offset: 0.6 },
        { opacity: 0.9, transform: 'scale(1)' }
      ], { duration: 900, delay: attente + duree * 0.42, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'both' });
      anims.push(ac);

      a.finished.then(() => {
        if (fini3) return;
        r.classList.add('on');
        const o = document.createElement('span');
        const t = Math.max(T.w, T.h) * 1.25;
        o.className = 'h3-anneau on';
        o.style.cssText = `left:${(cx - t / 2).toFixed(1)}px;top:${(cy - t / 2).toFixed(1)}px;width:${t.toFixed(1)}px;height:${t.toFixed(1)}px`;
        scene.appendChild(o);
        p.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 480, easing: 'ease', fill: 'forwards' });
        c.animate([{ opacity: 0.9, transform: 'scale(1)' }, { opacity: 0, transform: 'scale(.92)' }], { duration: 700, delay: 350, easing: 'ease', fill: 'forwards' });
        if (--restants === 0) setTimeout(terminer, 650);
      }).catch(() => {});
    });
  }

  function terminer() {
    if (fini3) return;
    fini3 = true;
    H.classList.add('h3-fin');
    setTimeout(() => { nettoyer(); H.classList.remove('h3-jouer'); }, 1500);
  }

  /* Si l'écran change de taille pendant l'animation, on montre directement le résultat */
  const surRedim = () => {
    if (fini3) return;
    fini3 = true;
    anims.forEach((a) => { try { a.cancel(); } catch (e) { /* déjà fini */ } });
    terminerVite();
  };
  let largeur = innerWidth;
  addEventListener('resize', () => { if (Math.abs(innerWidth - largeur) > 40) surRedim(); largeur = innerWidth; }, { passive: true });
})();
